import icon from '@material-ui/icons/Person'

import create from './create'
import edit from './edit'
import list from './list'

export default { list, edit, create, icon, options: { label: 'Events' } }
